import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { timeout, catchError } from 'rxjs/operators'
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

// timeout should be long enough to handle a slow backend / network but
// short enough to timeout before the user gets impatient
const TIMEOUT_MS = 20000

// use a longer timeout for config-related routes as they often rely on external APIs
const CONFIG_TIMEOUT_MS = 60000

@Injectable()
export class MyInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timeoutMs = request.url.includes('/config') ? CONFIG_TIMEOUT_MS : TIMEOUT_MS
    //console.debug('http interceptor url', request.url, timeoutMs)
    return next.handle(request).pipe(
      timeout(timeoutMs),
      catchError((err) => {
        console.debug('http interceptor err', err)
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            console.debug('intercepted 401 - logging out')
            // clear the stored token and redirect to the landing page
            // do not logout of Cognito as that can cause a loop
            this.authService.logout(false)
          }
        }
        return throwError(err)
      })
    )
  }
}